import React, { useEffect } from 'react'
import './App.css';
import GradeCalculator from './components/GradeCalculator'

function App() {
  return (
    <GradeCalculator />
  );
}

export default App;
